'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isUiTablet = exports.isUiMicrosoftBrowser = exports.getMobileBrowserOS = exports.isBrowserIE = exports.isUiMobile = exports.getUiBrowser = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _reselect = require('reselect');

var _client = require('./client');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// reducer
var DEFAULT_STATE = {
    deviceType: '',
    microsoftBrowser: false,
    mobile: '',
    name: ''
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _client.HYDRATE_CLIENT_STATE:
            return (0, _extends3.default)({}, state, action.payload.browser);
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.browser;
};

var getUiBrowser = exports.getUiBrowser = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state;
});

var isUiMobile = exports.isUiMobile = (0, _reselect.createSelector)(getUiBrowser, function (uiBrowser) {
    return uiBrowser.mobile;
});

var isBrowserIE = exports.isBrowserIE = (0, _reselect.createSelector)(getUiBrowser, function (uiBrowser) {
    return !!(uiBrowser.name && uiBrowser.name.toLowerCase() === 'ie');
});

var getMobileBrowserOS = exports.getMobileBrowserOS = (0, _reselect.createSelector)(getUiBrowser, function (uiBrowser) {
    return uiBrowser.mobile ? uiBrowser.os : '';
});

var isUiMicrosoftBrowser = exports.isUiMicrosoftBrowser = (0, _reselect.createSelector)(getUiBrowser, function (uiBrowser) {
    return uiBrowser.microsoftBrowser;
});

var isUiTablet = exports.isUiTablet = (0, _reselect.createSelector)(isUiMobile, function (mobile) {
    return mobile === 'tablet';
});


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/browser.js
// module id = aN2S
// module chunks = 60